module.exports = __webpack_public_path__ + "img/password-img.826b8907.svg";